import React from 'react'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

const TimeSlotTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow placement="bottom" classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    minWidth: 248,
    maxWidth: 248,
  },
}))

export default TimeSlotTooltip
